import { render, staticRenderFns } from "./AddTenancyTenancyTab.vue?vue&type=template&id=8129504a&scoped=true"
import script from "./AddTenancyTenancyTab.vue?vue&type=script&lang=js"
export * from "./AddTenancyTenancyTab.vue?vue&type=script&lang=js"
import style0 from "./AddTenancyTenancyTab.vue?vue&type=style&index=0&id=8129504a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8129504a",
  null
  
)

export default component.exports